<template>
    <div class="pp-container" 
        :class="{'is-vertical': isVertical, 'is-slide': hasSlideAside}">
        <slot></slot>
    </div>
</template>

<script>
/**
 * 外层容器
 * @desc 1.容器中的包含<pp-slide-aside>会自动左右排列，且隐藏侧边栏
 *       2.容器中包含<pp-header>,<pp-footer>会自动上下排列
 */
export default {
    name: 'pp-container',
    data: function() {
        return {
            hasHeader: false,
            hasFooter: false,
            hasSlideAside: false,
        }
    },
    computed: {
        isVertical: function() {
            return this.hasSlideAside 
                ? false 
                : this.hasHeader || this.hasFooter;
        },
    },
}
</script>
